import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@environments/environment';
import { getEnvironment } from 'bootstrap/get-environment';
import { showBootstrapError } from 'bootstrap/show-bootstrap-error';
import { initializeStartupDiagnostics } from 'bootstrap/startup-diagnostics';
import { registerLanguageFiles } from '@common/locales/translator';

initializeStartupDiagnostics();
getEnvironment()
  .then(async env => {
    env.api.baseUrl = '/api/';
    Object.assign(environment, env);

    await registerLanguageFiles([
      { language: 'en', loader: () => import('@assets/i18n/en') },
      { language: 'no', loader: () => import('@assets/i18n/no') },
      { language: 'en', loader: () => import('@assets/i18n/commonDir/en') },
      { language: 'no', loader: () => import('@assets/i18n/commonDir/no') }
    ]);

    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch(err => {
    console.error('Failed to bootstrap application:', err);
    showBootstrapError(err instanceof Error ? err : new Error(String(err)));
  });
